/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Banner_DescInputs */

const en_compliance_banner_desc = /** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To continue as a verified Business or NFP, please confirm your legal entity details. This is required for tax and branding compliance.`)
};

const es_compliance_banner_desc = /** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para continuar como Negocio u ONG verificada, confirma los detalles de tu entidad legal. Esto es necesario para el cumplimiento fiscal.`)
};

const fr_compliance_banner_desc = /** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour continuer en tant qu'Entreprise ou Association vérifiée, veuillez confirmer les détails de votre entité juridique. Ceci est requis pour la conformité fiscale.`)
};

const de_compliance_banner_desc = /** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um als verifiziertes Unternehmen fortzufahren, bestätige bitte die Daten deiner juristischen Person. Dies ist für steuerliche Zwecke erforderlich.`)
};

const id_compliance_banner_desc = /** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk melanjutkan sebagai Bisnis atau Organisasi Non-Profit terverifikasi, harap konfirmasi detail entitas hukum Anda. Hal ini diwajibkan untuk kepatuhan pajak dan merek.`)
};

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const ja_compliance_banner_desc = en_compliance_banner_desc;

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const zh_compliance_banner_desc = en_compliance_banner_desc;

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const ar_compliance_banner_desc = en_compliance_banner_desc;

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const it_compliance_banner_desc = en_compliance_banner_desc;

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const ru_compliance_banner_desc = en_compliance_banner_desc;

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const pt_compliance_banner_desc = en_compliance_banner_desc;

/** @type {(inputs: Compliance_Banner_DescInputs) => LocalizedString} */
const ko_compliance_banner_desc = en_compliance_banner_desc;

/**
* | output |
* | --- |
* | "To continue as a verified Business or NFP, please confirm your legal entity details. This is required for tax and branding compliance." |
*
* @param {Compliance_Banner_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const compliance_banner_desc = /** @type {((inputs?: Compliance_Banner_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Banner_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_compliance_banner_desc(inputs)
	if (locale === "es") return es_compliance_banner_desc(inputs)
	if (locale === "fr") return fr_compliance_banner_desc(inputs)
	if (locale === "de") return de_compliance_banner_desc(inputs)
	if (locale === "ja") return ja_compliance_banner_desc(inputs)
	if (locale === "zh") return zh_compliance_banner_desc(inputs)
	if (locale === "ar") return ar_compliance_banner_desc(inputs)
	if (locale === "id") return id_compliance_banner_desc(inputs)
	if (locale === "it") return it_compliance_banner_desc(inputs)
	if (locale === "ru") return ru_compliance_banner_desc(inputs)
	if (locale === "pt") return pt_compliance_banner_desc(inputs)
	return ko_compliance_banner_desc(inputs)
});